export const BANNER_HEIGHT = 882;
export const BANNER_HEIGHT_MOBILE = 488;
export const BANNER_BOTTOM_OVERLAY_OFFSET = 5;
